
import Vue from 'vue'
import { VLayout, VProgressCircular } from 'vuetify/lib'

export default Vue.extend({
  name: 'LoadingPage',
  components: { VProgressCircular, VLayout },
})
